module.exports = __webpack_public_path__ + "static/img/DYLAN-PATTERSON.5c3d7a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DYLAN-PATTERSON.jpg
// module id = IqvY
// module chunks = 0